import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class HttpInterceptorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');
    let headers: any = {
      'cache-control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      'If-Modified-Since': '0'
    };
    if (token) {
      headers['token'] = token;
    }
    if (req.body && !(req.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }
    const modifiedReq = req.clone({ setHeaders: headers });
    return next.handle(modifiedReq);
  }
}

